function reducer(state = [], action) {
    switch (action.type) {
        case 'FEES/TYPES/SET':
            return action.feeTypes;
        default:
            return state;
    }
}

export default reducer;
